var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 14.5,
    viewBox: "0 0 17.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-email",
    transform: "translate(0.25 -5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(12.03 7.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M37.789,11.586h-1v.979h-.938V13.6h.938v.979h1V13.6h.939V12.565h-.939Z",
    transform: "translate(-35.855 -11.586)",
    fill: "#025376",
    stroke: "#025376",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M17,9.02a3.617,3.617,0,0,0-3.534-3.686A3.592,3.592,0,0,0,9.967,8.5H0V19.334H17ZM13.466,6.373A2.6,2.6,0,0,1,16,9.021a2.541,2.541,0,1,1-5.077,0A2.6,2.6,0,0,1,13.466,6.373ZM8.5,16.456,11,14.879l4.081,3.416H1.94l4.129-3.379Zm0-1.215-6.308-4a2.614,2.614,0,0,1-1.144-1.7h8.92a3.64,3.64,0,0,0,2.705,3.075ZM1.674,12.127,5.16,14.339,1,17.747V11.563a3.476,3.476,0,0,0,.678.564ZM16,17.735l-4.1-3.428s3.9-2.517,4.1-2.724Z",
    transform: "translate(0 0)",
    fill: "#025376",
    stroke: "#025376",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmail);
export default __webpack_public_path__ + "static/media/new-email.b66101c8a91647b756de1a7581a93cb2.svg";
export { ForwardRef as ReactComponent };